




















import { defineComponent } from '@vue/composition-api'
import SortProductsList from '@/views/catalog/manageList/SortProductsList.vue'
import QueryInput from '@/views/catalog/manageList/QueryInput.vue'
import ProductsFromCatalogStore from '@/store/productsList/productsFromCatalog'

export default defineComponent({
  name: 'ProductListManage',
  components: {
    QueryInput, SortProductsList,
  },
  data() {
    return {
      catalogId: 'not-set',
    }
  },
  mounted() {
    this.getProductsData()
  },
  created() {
    this.catalogId = this.$route.params.catalogId
  },
  methods: {
    getProductsData() {
      ProductsFromCatalogStore.commit('setCatalogId', this.catalogId)
      ProductsFromCatalogStore.dispatch('getProductsFromCatalog')
    },
  },
})
